export default __webpack_public_path__ + "static/media/sparkles-current-color.cb67e797.svg";